module.exports = __webpack_public_path__ + "images/lada8933548cb7302f4122898958cf35e2cc.png";